"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var icon_close_modal_svg_1 = __importDefault(require("@assets/icons/icon_close_modal.svg"));
var swiper_1 = __importStar(require("swiper"));
var lodash_1 = __importDefault(require("lodash"));
var react_use_1 = require("react-use");
var react_2 = require("swiper/react");
var react_reverse_portal_1 = require("react-reverse-portal");
var ArrowButton_1 = __importDefault(require("@common/arrowButton/ArrowButton"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
require("swiper/swiper-bundle.min.css");
require("swiper/swiper.min.css");
var mediasSlice_1 = require("../../state/mediasSlice");
var FullImage_1 = __importDefault(require("../FullImage"));
var VideoPlayer_1 = __importDefault(require("../VideoPlayer"));
var VideoSized_1 = __importDefault(require("../VideoSized"));
var SizedImage_1 = __importDefault(require("../SizedImage"));
var store_1 = require("@/redux/store");
var LAST_VISIBLE_IMAGE_INDEX = 9;
var initializeLastSlideIndex = function (mediasLength) {
    return mediasLength <= LAST_VISIBLE_IMAGE_INDEX ? mediasLength - 1 : LAST_VISIBLE_IMAGE_INDEX;
};
swiper_1.default.use([swiper_1.Navigation]);
function MediaGalleryModal(props) {
    var closeModal = props.closeModal, showBoundingBox = props.showBoundingBox, adId = props.adId, portalNode = props.portalNode, isUsingPortal = props.isUsingPortal;
    var dispatch = (0, store_1.useAppDispatch)();
    var imagesMetadata = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.imagesMetadataSelector)(state, adId); });
    var videosMetadata = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.videosMetadataSelector)(state, adId); });
    var mediaMetadata = __spreadArray(__spreadArray([], __read(imagesMetadata), false), __read(videosMetadata), false);
    var selectedMedia = (0, react_redux_1.useSelector)(function (state) { return (0, mediasSlice_1.selectedMediaSelector)(state, adId); });
    var selectedMediaId = selectedMedia.id;
    var mediasLength = mediaMetadata.length;
    var lastMediaIndex = mediaMetadata.length - 1;
    var isVideo = selectedMedia ? selectedMedia.type === 'video' : false;
    var isPlaying = selectedMedia && isVideo && selectedMedia.isPlaying;
    var selectedMediaIndex = mediaMetadata.findIndex(function (metadata) { return metadata.id === selectedMediaId; });
    var _a = __read((0, react_1.useState)(), 2), swiperInstance = _a[0], setSwiperInstance = _a[1];
    var _b = __read((0, react_1.useState)(null), 2), prevEl = _b[0], setPrevEl = _b[1];
    var _c = __read((0, react_1.useState)(null), 2), nextEl = _c[0], setNextEl = _c[1];
    var _d = __read((0, react_1.useState)(initializeLastSlideIndex(mediasLength)), 2), lastSlideIndex = _d[0], setLastSlideIndex = _d[1];
    var isFirstMount = (0, react_use_1.useFirstMountState)();
    var getFirstSlideIndex = function () {
        return lastSlideIndex - LAST_VISIBLE_IMAGE_INDEX >= 0 ? lastSlideIndex - LAST_VISIBLE_IMAGE_INDEX : 0;
    };
    var selectPreviousMedia = function () {
        var index = mediaMetadata.findIndex(function (metadata) { return metadata.id === selectedMediaId; });
        var previousIndex = index - 1;
        previousIndex >= 0 && dispatch((0, mediasSlice_1.setSelectedMediaId)({ adId: adId, selectedMediaId: mediaMetadata[previousIndex].id }));
    };
    var selectNextMedia = function () {
        var index = mediaMetadata.findIndex(function (metadata) { return metadata.id === selectedMediaId; });
        var nextIndex = index + 1;
        nextIndex <= lastMediaIndex && dispatch((0, mediasSlice_1.setSelectedMediaId)({ adId: adId, selectedMediaId: mediaMetadata[nextIndex].id }));
    };
    var handleLeftArrowClick = function () {
        selectPreviousMedia();
        var firstSlideIndex = getFirstSlideIndex();
        if (!lodash_1.default.inRange(selectedMediaIndex, firstSlideIndex, lastSlideIndex)) {
            swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideTo(selectedMediaIndex - 10);
        }
        else if (firstSlideIndex !== 0 && firstSlideIndex === selectedMediaIndex) {
            swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slidePrev();
        }
    };
    var handleRightArrowClick = function () {
        selectNextMedia();
        var firstSlideIndex = getFirstSlideIndex();
        if (!lodash_1.default.inRange(selectedMediaIndex, firstSlideIndex, lastSlideIndex)) {
            swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideTo(selectedMediaIndex - 8);
        }
        else if (lastSlideIndex === selectedMediaIndex && lastSlideIndex !== lastMediaIndex) {
            swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideNext();
        }
    };
    var onSlideChange = function (_a) {
        var activeIndex = _a.activeIndex, previousIndex = _a.previousIndex;
        if (!isFirstMount) {
            var indexChange_1 = Math.abs(activeIndex - previousIndex);
            setLastSlideIndex(function (index) { return (activeIndex > previousIndex ? index + indexChange_1 : index - indexChange_1); });
        }
    };
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (e) {
            var key = e.key;
            if (key === 'ArrowLeft') {
                handleLeftArrowClick();
            }
            if (key === 'ArrowRight') {
                handleRightArrowClick();
            }
            if (key === 'Escape') {
                closeModal(e);
            }
            if (key === ' ') {
                isPlaying ? dispatch((0, mediasSlice_1.pause)({ adId: adId })) : dispatch((0, mediasSlice_1.play)({ adId: adId }));
            }
            if (key === 'Enter') {
                isPlaying ? dispatch((0, mediasSlice_1.pause)({ adId: adId })) : dispatch((0, mediasSlice_1.play)({ adId: adId }));
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () { return window.removeEventListener('keydown', handleKeyDown); };
    }, [selectedMediaId, lastSlideIndex, swiperInstance, isPlaying]);
    (0, react_1.useEffect)(function () {
        window.addEventListener('popstate', closeModal);
        return function () { return window.removeEventListener('popstate', closeModal); };
    }, []);
    var imageGalleryHeight = 150;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var modalMainImageContainerSize = {
        height: windowHeight - imageGalleryHeight,
        width: windowWidth,
    };
    return (react_1.default.createElement("div", { id: "media-gallery-modal", className: "media-gallery-modal-container" },
        react_1.default.createElement("div", { className: "media-viewer", style: { height: 'calc(100% - 150px)' } },
            react_1.default.createElement(ArrowButton_1.default, { id: "media-viewer-btn-prev", onClick: handleLeftArrowClick, isHidden: selectedMediaIndex === 0 }),
            mediasLength !== 0 && isUsingPortal && react_1.default.createElement(react_reverse_portal_1.OutPortal, { node: portalNode }),
            mediasLength !== 0 && (videosMetadata === null || videosMetadata === void 0 ? void 0 : videosMetadata.length) !== 0 && isVideo && !isUsingPortal && (react_1.default.createElement(VideoPlayer_1.default, { isEditModeEnabled: false, fullImageContainerSize: { width: '100%', height: '100%' }, adId: adId, showVideoActionIcons: false, isHovered: false })),
            mediasLength !== 0 && (imagesMetadata === null || imagesMetadata === void 0 ? void 0 : imagesMetadata.length) !== 0 && !isVideo && !isUsingPortal && selectedMediaId && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(FullImage_1.default, { imageId: selectedMediaId, adId: adId, containerSize: modalMainImageContainerSize, showImageActionIcons: false, isEditModeEnabled: false, showBoundingBox: showBoundingBox, showBoundingBoxLabel: true, imageCroppingAllowed: false, imageRotationAllowed: false, isHovered: false, isModalOpen: true, isClickable: false }))),
            react_1.default.createElement(ArrowButton_1.default, { id: "media-viewer-btn-next", onClick: handleRightArrowClick, isHidden: selectedMediaIndex === lastMediaIndex })),
        react_1.default.createElement("div", { className: "media-gallery", style: { zIndex: 1031, backgroundColor: 'white' } },
            react_1.default.createElement("i", { ref: function (node) { return setPrevEl(node); }, className: "implioicons-chevron-left", style: { visibility: lastSlideIndex <= LAST_VISIBLE_IMAGE_INDEX ? 'hidden' : 'visible' }, id: "btn-prev" }),
            react_1.default.createElement(react_2.Swiper, { onInit: function (swiper) { return setSwiperInstance(swiper); }, initialSlide: selectedMediaIndex - LAST_VISIBLE_IMAGE_INDEX >= 0 ? selectedMediaIndex - LAST_VISIBLE_IMAGE_INDEX : 0, slidesPerView: mediasLength > LAST_VISIBLE_IMAGE_INDEX ? 10 : mediasLength, navigation: { prevEl: prevEl, nextEl: nextEl }, onSlideChange: onSlideChange, className: "item-group-container", spaceBetween: 10 },
                imagesMetadata.map(function (metadata, index) { return (react_1.default.createElement(react_2.SwiperSlide, { key: metadata.id },
                    react_1.default.createElement(SizedImage_1.default, { key: metadata.id, adId: adId, imageId: metadata.id, showBoundingBox: showBoundingBox, imageMetadata: imagesMetadata[index], isModalOpen: false }))); }),
                videosMetadata.map(function (metadata) { return (react_1.default.createElement(react_2.SwiperSlide, { key: metadata.id },
                    react_1.default.createElement(VideoSized_1.default, { adId: adId, videoId: metadata.id, key: metadata.id, containerSize: { width: 84, height: 84 } }))); })),
            react_1.default.createElement("i", { ref: function (node) { return setNextEl(node); }, className: "implioicons-chevron-right", style: {
                    visibility: mediasLength <= LAST_VISIBLE_IMAGE_INDEX || lastSlideIndex === lastMediaIndex ? 'hidden' : 'visible',
                }, id: "btn-next" })),
        react_1.default.createElement("div", { className: "modal-close-btn" },
            react_1.default.createElement("img", { src: icon_close_modal_svg_1.default, onClick: closeModal }))));
}
exports.default = MediaGalleryModal;
